import { TeamLogo } from "../../../../components/shared/team-logo";
import "./lineup.css";

const pos = (position) => {
  if (!position) return "";
  return String(position).split("/")[0].split(",")[0].trim().toUpperCase();
};

const PlayerName = (props) => {
  const { player_id, player_name } = props;
  const cls = `lineup-name${player_id ? " lineup-name--link" : ""}`;
  return player_id ? (
    <a href={`/player/${player_id}`} target="_blank" rel="noreferrer" className={cls}>
      {player_name || "Unknown"}
    </a>
  ) : (
    <span className={cls}>{player_name || "Unknown"}</span>
  );
};

export const PitchingLineup = (props) => {
  const { lineup, teamName, teamId } = props;

  if (!lineup || lineup.length === 0) {
    return <div className="lineup-empty">No pitching data available</div>;
  }

  const sorted = [...lineup].sort((a, b) => (a.pitch_order || 999) - (b.pitch_order || 999));

  return (
    <div>
      <div className="lineup-header">
        <TeamLogo teamId={teamId} teamName={teamName} size="w-6 h-6" />
        <h3>{teamName} Pitchers</h3>
      </div>
      <div>
        {sorted.map((player, idx) => (
          <div key={idx} className="lineup-row">
            <span className="lineup-order">{player.pitch_order || idx + 1}</span>
            <PlayerName player_id={player.player_id} player_name={player.player_name} />
            <span className="lineup-position">{pos(player.position)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
